import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Modal
} from 'react-bootstrap';

import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { closeSmtpSetupModal } from '../../../../actions/siteadmin/modalActions';
import SmtpForm from '../SmtpForm/SmtpForm';
import s from './SmtpModal.css';
import messages from '../../../../locale/jsonMessages';

class SmtpModal extends Component {
  static defaultProps = {
    smtpSetupModalType: 'add'
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { closeSmtpSetupModal, smtpSetupModal, smtpSetupModalType, paginationData, currentPage, smtpSetupModalData } = this.props;
    return (
      <Modal show={smtpSetupModal} onHide={closeSmtpSetupModal} dialogClassName='commonModalContainer globalModalContainer'>
        <Modal.Header closeButton className='commonModalHeader'>
          <Modal.Title className='commonModalTitle'>
            {smtpSetupModalType == 'add' ? <FormattedMessage  {...messages.addLabel} /> : <FormattedMessage  {...messages.editLabel} />} <FormattedMessage  {...messages.smtpCredentialsLabel} /></Modal.Title>
        </Modal.Header>
        <Modal.Body bsClass='commonModalBody'>
          <SmtpForm paginationData={paginationData} currentPage={currentPage} initialValues={smtpSetupModalData} />
        </Modal.Body>
      </Modal>
    )
  }
}

const mapState = (state) => ({
  smtpSetupModal: state?.adminModalStatus?.smtpSetupModal,
  smtpSetupModalType: state?.adminModalStatus?.smtpSetupModalType,
  smtpSetupModalData: state?.adminModalStatus?.smtpSetupModalData
});

const mapDispatch = {
  closeSmtpSetupModal
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(SmtpModal)));
